export default "__VITE_ASSET__B1E4dWfm__"